import moment from "moment";

export type FreezeDryBatchStatus = "active" | "historic" | "future";

/**
 * A freeze-dried batch is:
 * - "future" when the freeze-dry start date is in the future
 * - "historic" when the freeze-dry end date is more than one week ago
 * - "active" otherwise (currently running or recently finished)
 */
export const getFreezeDryBatchStatus = (
  freezeDryStart: number | null | undefined,
  freezeDryEnd: number | null | undefined,
): FreezeDryBatchStatus => {
  if (freezeDryStart && moment(freezeDryStart).isAfter(moment(), "day")) return "future";
  const end = freezeDryEnd || freezeDryStart;
  if (end && moment(end).isBefore(moment().subtract(1, "week"))) return "historic";
  return "active";
};

export const freezeDryBatchStatusLabel: Record<FreezeDryBatchStatus, string> = {
  active: "Aktiva",
  historic: "Historiska",
  future: "Framtida",
};